// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"d09337cd","194":"13004e50","315":"25c3bdab","543":"a78e78c8","580":"2ffa4569","679":"ee69c0c4","709":"74dfdeea","926":"ee69c0c4"}[chunkId] + ".chunk.css";
};